<div class="wms-toggle {{customClasses}}" id="{{name}}" tabindex="0" (focus)="handleFocus($event)" [ngClass]="{'disabled': disabled}">
    <span *ngIf="!hideLabels" class="on-label">{{offLabel || locale.LABEL_OFF}}</span>
    <input [disabled]="disabled" id="toggle-checkbox-{{id}}" type="checkbox" name="{{name}}" [ngClass]="{'ng-empty': !model, 'ng-not-empty': model}" [(ngModel)]="model" (ngModelChange)="handleChange($event)" />
    <label for="toggle-checkbox-{{id}}"></label>
  <span *ngIf="!hideLabels" class="off-label">{{onLabel || locale.LABEL_ON}}</span>
</div>
